import React, { type PropsWithChildren, memo } from "react";
import PanelVariant, { type PanelVariants } from "./Panel.styles";
import * as Styles from "./Panel.styles";

export type PanelVariantsType = keyof typeof PanelVariants;

type PanelProps = {
    variant: PanelVariantsType;
    active?: boolean;
    header?: JSX.Element;
};

const Panel: React.FC<PropsWithChildren<PanelProps>> = (props) => {
    const { variant, active, header, children } = props;
    return (
        <PanelVariant variant={variant} active={active}>
            {header && <Styles.Header>{header}</Styles.Header>}
            {children}
        </PanelVariant>
    );
};

export default memo(Panel);
